// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"sideDrawer__SideDrawer__3qPcG","Open":"sideDrawer__Open__2evUm","Close":"sideDrawer__Close__2m2Qg","Logo":"sideDrawer__Logo__1LEPA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/sideDrawer/sideDrawer.css
// module id = 34
// module chunks = 0